import React, { useContext, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./City_Container.css";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";

function City_Scroller({ data }) {
  const [selectedCity, setSelectedCity] = useState(null);

  const navigate = useNavigate();

  return (
    <section className="city-scroller-section">
      <div className="container">
        <Swiper
          spaceBetween={20}
          slidesPerView={10}
          modules={[Autoplay, Navigation]}
          navigation
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          speed={100}
          breakpoints={{
            320: { slidesPerView: 3 },
            480: { slidesPerView: 4 },
            768: { slidesPerView: 7 },
            1024: { slidesPerView: 10 },
          }}
          className="city-swiper"
        >
          {data?.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className={`city-item ${
                  selectedCity === index ? "selected" : ""
                }`}
                onClick={() => {
                  navigate(`/home/holidays/city-break/${item.id}`);
                }}
              >
                <div className="city-card">
                  <div className="city-img">
                    <img src={item?.image} alt={item?.label} />
                  </div>
                </div>
                <p className="city-label">{item?.name}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default City_Scroller;
